import React, { useEffect, useState } from 'react'
import { Card, Flexbox } from '@/components'
import { Button } from '@/components/styles'
import home from '@/services/api/home'
import { toast } from 'react-toastify'
import ChartLine from '../ChartLine'

function CastrationsRequestedByMonthCard() {
  const [chartData, setChartData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [monthOffset, setMonthOffset] = useState(0)

  useEffect(() => {
    let cancelled = false
    async function fetchChart() {
      try {
        setLoading(true)
        const res = await home.dashboard(monthOffset)
        if (!cancelled) {
          setChartData(res.data.requestedCastrationsByMonth)
        }
      } catch (e) {
        if (!cancelled) toast.error(e?.message)
      } finally {
        if (!cancelled) setLoading(false)
      }
    }

    fetchChart()
    return () => {
      cancelled = true
    }
  }, [monthOffset])

  const prev = chartData?.length === 6 && !loading
  const next = monthOffset > 0 && !loading

  return (
    <Card.Base>
      <Card.Header>
        <Flexbox.Columns className="align-center">
          <Flexbox.Column className="col-auto">
            <i className="fas fa-cut fa-lg" />
          </Flexbox.Column>
          <Flexbox.Column>
            <div className="h5">Castrações mensais solicitadas</div>
          </Flexbox.Column>
        </Flexbox.Columns>
      </Card.Header>
      <Card.Body>
        <ChartLine
          data={chartData || []}
          lineDataKey="Castrações solicitadas"
          xAxisDataKey="monthString"
          isAnimationActive={!loading}
        />
        <Flexbox.Columns className="justify-between mt-2">
          <Button onClick={() => setMonthOffset((s) => s + 1)} disabled={!prev}>
            <i className="fas fa-arrow-left" /> Mês anterior
          </Button>
          <Button
            onClick={() => setMonthOffset((s) => Math.max(0, s - 1))}
            disabled={!next}
            className="ml-2 pl-2"
          >
            Próximo mês <i className="fas fa-arrow-right" />
          </Button>
        </Flexbox.Columns>
      </Card.Body>
    </Card.Base>
  )
}

export default CastrationsRequestedByMonthCard
